export const allproducts = {
  // stupiditems: [
  //   {
  //     productName: "eyelash curler",
  //     price: 50,
  //     description: "curl like a hoe",
  //   },
  //   {
  //     productName: "Clips",
  //     price: 250,
  //     description: "clips your hair tightly",
  //   },
  //   {
  //     productName: "Nails",
  //     price: 20,
  //     description: "scratch your ass nicely",
  //   },
  //   {
  //     productName: "Lipstick",
  //     price: 120,
  //     description: "to look like a clown",
  //   },
  //   {
  //     productName: "Hat",
  //     price: 70,
  //     description: "hide yourself being a pervert",
  //   },
  // ],
  bathitems: [
    {
      productName: "soap",
      price: 501,
      description: "something for your skin",
    },
    {
      productName: "shampoo",
      price: 500,
      description: "wash your hair with it",
    },

    {
      productName: "conditioners",
      price: 250,
      description: "moisturise your hair after bath",
    },
    {
      productName: "brush",
      price: 20,
      description: "cleans your teeth nicely",
    },
    {
      productName: "towel",
      price: 120,
      description: "wipe your body dry",
    },
    {
      productName: "cleaner",
      price: 70,
      description: "get rid of dirt from your home",
    },
  ],
  groceries: [
    {
      productName: "apple",
      price: 50,
      description: "say goodbye to doctors",
    },
    {
      productName: "banana",
      price: 500,
      description: "cheapest fruit you can buy",
    },

    {
      productName: "mango",
      price: 250,
      description: "amazing for juices",
    },
    {
      productName: "kiwi",
      price: 20,
      description: "great for health",
    },
    {
      productName: "orange",
      price: 120,
      description: "sweet and sour juice to drink",
    },
    {
      productName: "watermelon",
      price: 70,
      description: "cool your body with watermelon juice",
    },
  ],
};
